import { UnderMaintenance } from '@/components/ui';

export const ReportDaily = () => {
    return <UnderMaintenance />;
};

ReportDaily.displayName = 'ReportDaily';
